import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { formatDate, isValidDateString } from 'ziphy-web-shared/basic/utils/time';
import styles from './DateTime.module.scss';
const DateTime = ({ datetime }) => {
    if (!isValidDateString(datetime))
        return null;
    return _jsxs("span", Object.assign({ className: styles.container }, { children: [" \u2022 ", formatDate(datetime, 'datetime')] }));
};
export default DateTime;
